<template>
    <div class="wrapper">
        <v-headNext></v-headNext>
        <v-sidebarNext></v-sidebarNext>
        <div class="content-box" :class="{'content-collapse':collapse}">
            <v-tags></v-tags>
            <div class="content">
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view></router-view>
                    </keep-alive>
                </transition>
                <el-backtop target=".content"></el-backtop>
            </div>
        </div>
    </div>
</template>

<script>
import vHeadNext from './HeaderNext.vue';
import vSidebarNext from './SidebarNext.vue';
import vTags from './Tags.vue';
import bus from './bus';
export default {
    data() {
        return {
            tagsList: [],
            collapse: false
        };
    },
    components: {
        vHeadNext,
        vSidebarNext,
        vTags
    },
    created() {
        bus.$on('collapse-content', msg => {
            this.collapse = msg;
        });

        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', msg => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        });
            if(window.location.hash.substring(1).split("?")[1]!=null){
                var companyid = window.location.hash.substring(1).split("?")[1].split("&")[0].split("=")[1];
                var companyname =  decodeURI(window.location.hash.substring(1).split("?")[1].split("&")[1].split("=")[1]);
                sessionStorage.setItem('companyname',companyname)
                sessionStorage.setItem('companyid',companyid)
            }
           
      
      
    }
};
</script>
